
const Player = {
  schema: {
    autoRotate: { label: 'Auto-Rotate Camera', type: 'Boolean', defaultValue: false },
    autoRotateNode: { label: 'Rotate Node', type: 'Node' },
    autoRotateSpeed: { label: 'Rotate Speed (seconds)', type: 'Number', minValue: 1, maxValue: 60, defaultValue: 12 },
    autoRotateDirection: { label: 'Rotate Direction', type: 'Options', values: ['-', '+'], labels: ['Clockwise', 'Counter-clockwise'], defaultValue: '-' },

    camera: { label: 'Camera', type: 'Node' },
    constraintCameraY: { label: 'Constrain Camera to Positive Y', type: 'Boolean', defaultValue: false },
    orbitTarget: { label: 'Orbit Target', type: 'Node' },
    orbitMode: { label: 'Orbit Mode', type:  'Options', values: ['gyroscope', 'trackball', 'firstPerson'], labels: ['Gyropscope', 'Trackball', 'First Person'], defaultValue: 'gyroscope' },

    toneMapStyle: { label: 'Style', type: 'Options', values: ['Linear', 'Reinhard', 'Cineon', 'Filmic'], defaultValue: 'Linear' },
    toneMapExposureGain: { label: 'Exposure Gain', type: 'Number', defaultValue: 1.0, minValue: 0.0, maxValue: 20.0, step: 0.1 },
    toneMapWhitePoint: { label: 'White Point', type: 'Number', defaultValue: 4.0, minValue: 0.0, maxValue: 20.0, step: 0.1 },

    dofPass: { label: 'Enabled', type: 'Boolean', defaultValue: false },
    dofMaxBlur: { label: 'Max Blur', type: 'Number', defaultValue: 10.0, minValue: 0.0, maxValue: 100.0, step: 0.1 },

    saoPass: { label: 'Enabled', type: 'Boolean', defaultValue: false },
    saoIntensity: { label: 'Intensity', type: 'Number', defaultValue: 1.0, minValue: 0.0, maxValue: 1000.0, step: 0.1 },
    saoScale: { label: 'Scale', type: 'Number', defaultValue: 24.0, minValue: 0.0, maxValue: 1000.0, step: 0.1 },

    bloomPass: { label: 'Enabled', type: 'Boolean', defaultValue: false },
    bloomThreshold: { label: 'Luminance Threshold', type: 'Number', defaultValue: 0.9, minValue: 0.0, maxValue: 1.0, step: 0.1 },
    //bloomBlendRange: { label: 'Blend Range', type: 'Number', defaultValue: 0.1, minValue: 0.0, maxValue: 10.0, step: 0.1 }, //not configurable in threejs yet

    reflectiveFloor: { label: 'Enabled', type: 'Boolean', defaultValue: false },
    reflectiveFloorWidth: { label: 'Width', type: 'Number', defaultValue: 1.0, minValue: 0.0, maxValue: 1000.0, step: 1.0 },
    reflectiveFloorRoughness: { label: 'Roughness', type: 'Number', defaultValue: 0.0, minValue: 0.0, maxValue: 10.0, step: 0.1 },
    reflectiveFloorMetallic: { label: 'Metallic', type: 'Number', defaultValue: 0.0, minValue: 0.0, maxValue: 1.0, step: 0.1 },
    reflectiveFloorFade: { label: 'Fade', type: 'Number', defaultValue: 0.0, minValue: 0.0, maxValue: 10000.0, step: 0.1 },
    reflectiveFloorHeight: { label: 'Height', type: 'Number', defaultValue: 0.0, minValue: -100.0, maxValue: 100.0, step: 0.1 },
    reflectiveFloorOpacity: { label: 'Opacity', type: 'Number', defaultValue: 1.0, minValue: 0.0, maxValue: 1.0, step: 0.1 },
    reflectiveFloorFresnel: { label: 'Fresnel Strength', type: 'Number', defaultValue: 1.0, minValue: -1.0, maxValue: 1.0, step: 0.1 },
    reflectiveFloorExcludeServer: { label: 'Exclude on Server', type: 'Boolean', defaultValue: false },

    configurator: { label: 'Configurator', type: 'String', hidden: true, defaultValue: '{}' },

    // Physics
    gravity: { label: 'Gravity', type: 'Vec3', step: 1.0, defaultValue: [0.0, -9.8, 0.0] },
  },
};

export default { Player };



// WEBPACK FOOTER //
// ./src/operators/Player.js